import React, { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import screenshots from "../assets/screenshots";

function Dashboard() {
  const { t, locale } = useLanguage();
  const [zoomed, setZoomed] = useState(null);

  const shots = [
    { src: screenshots[locale].dashboardHome, alt: t.dashboard.homeAlt },
    { src: screenshots[locale].dashboardExpenses, alt: t.dashboard.expensesAlt },
  ];

  useEffect(() => {
    if (!zoomed) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setZoomed(null);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [zoomed]);

  return (
    <section id="dashboard" className="dashboard-section">
      <div className="dashboard-header">
        <div className="story-tag">{t.dashboard.tag}</div>
        <h2>{t.dashboard.title}</h2>
        <p>{t.dashboard.description}</p>
      </div>

      <div className="dashboard-shots">
        {shots.map((shot) => (
          <button
            type="button"
            key={shot.alt}
            className="dashboard-shot"
            onClick={() => setZoomed(shot)}
            aria-label={t.dashboard.zoomHint}
          >
            <img src={shot.src} alt={shot.alt} />
          </button>
        ))}
      </div>

      {zoomed && (
        <div className="lightbox" onClick={() => setZoomed(null)}>
          <button
            type="button"
            className="lightbox-close"
            aria-label="Close"
            onClick={() => setZoomed(null)}
          >
            ×
          </button>
          <img
            src={zoomed.src}
            alt={zoomed.alt}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}

export default Dashboard;
